<div class="mmc-reporting-and-invoice-container">

    <div class="block">
        <button class="btn-medium-secondary" (click)="showFormForNewReport()" [style.display]="!showNewReportForm ? 'inline-block' : 'none'">Add new report</button>
    </div>

    @if(showNewReportForm) {
        <div class="block irb-lite-green-background" style="padding: 10px; width: 440px;">
            <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                <div class="bold" style="width: 150px">AS Firm ID</div>
                <div>
                    <div class="hblock">
                        <irb-validation-text-box #asFirmidBox
                                             max="15"
                                             [(value)]="newAsFirmId"
                                             width="278px"
                                             [isRequired]="newAsFirmIdRequired"
                                             [regExp]="'^[0-9]+$'"
                                             invalidMessage="The value entered is not valid."
                    ></irb-validation-text-box></div>
                </div>
            </div>
            <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                <div class="bold" style="width: 150px">MMC Reporting Master</div>
                <div>
                    <div class="hblock">
                        <irb-validation-text-box #reportMasterAccountBox
                                                 max="12"
                                                 [(value)]="newReportMasterAccount"
                                                 width="278px"
                                                 [isRequired]="newReportMasterAccountRequired"
                                                 invalidMessage="The value entered is not valid."
                        ></irb-validation-text-box></div>
                </div>
            </div>
            <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                <div class="bold" style="width: 150px">Reporting Request</div>
                <div>
                    <div class="hblock">
                        <irb-dropdown-search-multiple #reportTypeDropDown id="reportTypeDropDownId"
                                                      [(values)]="newReportType" (search)="setReportTypeDropDown($event)"
                                                      width="275" (selection)="onReportTypeChange()"
                                                      [enableEmptySearchTerm]="true"
                                                      [showAsAll]="true" [showApplyButton]="true"
                                             ></irb-dropdown-search-multiple>
                    </div>
                </div>
            </div>
            <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
                <div class="bold" style="width: 150px">User ID of Requestor</div>
                <div>
                    <div class="hblock">
                        <irb-validation-text-box #requestorUserIdBox
                                                 max="30"
                                                 [(value)]="newRequestorUserId"
                                                 width="278px"
                                                 [isRequired]="newRequestorUserIdRequired"
                                                 invalidMessage="The value entered is not valid."
                        ></irb-validation-text-box></div>
                </div>
            </div>
            <div style="text-align: right;">
                <button class="btn-medium-secondary" id="addButton" (click)="showNewReportForm=false">Close</button>
                <button class="btn-medium-secondary btn-spacer" id="addButton" (click)="addReporting()">Add</button>
            </div>
        </div>
    }

    <div class='loading-spinner' *ngIf="!dataLoaded"></div>
    @if(!isUiTest && dataLoaded) {
        <irb-inventory-grid
                class="mmc-reporting-and-invoice-class-grid-ag"
                [style.width]="'100%'"
                [style.height]="'240px'"
                [showSideBar]="false"
                [gridOptions]="gridOptions"
                [frameworkComponents]='frameworkComponents'
                (gridReady)="onGridReady($event)"></irb-inventory-grid>
        <div class="note hint">Any changes in grid will be saved automatically</div>
    }

</div>
